import { BedroomsContainer } from '../../containers/advancedFilters/BedroomsContainer';
import { IFilter } from '../../types/advancedFilters';

export const bedrooms: IFilter = {
  component: BedroomsContainer,
};
